import "./assets/styles/main.css";

import { createApp, type Plugin } from "vue";
import { createPinia } from "pinia";
import i18nConfig from "@/locales/i18n";
import App from "./App.vue";
import router from "./router";
import settings from "@/lib/environment-variables";
import axiosPlugin from "@/plugins/axios-plugin";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { initialize } from "@open-iframe-resizer/core";
import "./assets/styles/main.less";
import "./assets/styles/main.scss";
import { VueReCaptcha } from "vue-recaptcha-v3";
import "localcopy-fontawesome-pro/css/all.css";

const app = createApp(App);

//Ajout du plugin Axios pour configuré des valuers globales et ne pas à les resaisir à chaque instance axios
app.use(axiosPlugin.install, {
	api: settings.apiSetting.name,
	baseURL: settings.apiSetting.url,
	withCredentials: settings.apiSetting.withCredentials,
});
//Ajout du plugin i18n pour la traduction
app.use(i18nConfig.i18n);
app.provide("i18n", i18nConfig.i18n.global);
app.use(createPinia());
app.use(router);

app.use(VueReCaptcha, {
	siteKey: "6Le0q7UrAAAAADBI-PrmWxOcxR2TrfWH1oeTkCUn",
} as any);
app.mount("#app");
